"use strict";
// Copyright (c) StrangeBee 2024
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
class AttackPatternsController extends __1.ParentController {
    constructor() {
        super(...arguments);
        this.endpoints = {
            import: ':apiVersion/pattern/import/attack',
        };
    }
    create({}) {
        throw new Error("Can't create attack patterns!");
    }
    edit({}) {
        throw new Error("Can't edit attack patterns!");
    }
    delete() {
        throw new Error("Can't delete attack patterns!");
    }
    import(formData) {
        return this.manager.post({ url: this.endpoints.import, params: { apiVersion: 'v1' } }, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    }
}
exports.default = AttackPatternsController;
